import React, { useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import { graphql, StaticQuery, Link } from 'gatsby';
import lang from '../../static/lang.json';
import { filterByLocale } from '../helpers/iterators';
import { generateSlug } from '../helpers/slug';
import vars from '../lib/styled';
import Grid from './Grid';
import Locale from './Locale';
import HoneyPot from './HoneyPot';
import Input from './Input';
import Button from './Button';
import Alert from './Alert';
import FooterSearchBar from './FooterSearchBar';

const Footer = styled.footer`
    background-color: ${vars.contrast};
`;

const FooterContainer = styled.div`
    padding: 0 3rem 1rem;
    margin: 2rem auto;
    width: ${vars.container};
`;

const FooterLeftColumn = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 60%;

    @media (max-width: ${vars.breakpoint.laptop}) {
        justify-content: flex-start;
        width: 50%;
    }

    @media (max-width: ${vars.breakpoint.tablet}) {
        width: 100%;
    }
`;

const FooterRightColumn = styled(Form)`
    width: 40%;

    @media (max-width: ${vars.breakpoint.laptop}) {
        width: 50%;
    }

    @media (max-width: ${vars.breakpoint.tablet}) {
        width: 100%;
    }
`;

const FooterList = styled.ul`
    list-style: none;
    margin-bottom: 1rem;
    margin-left: 0;
    margin-right: 6vw;
    padding-left: 0;

    @media (max-width: ${vars.breakpoint.tablet}) {
        width: 100%;
    }
`;

const FooterListItem = styled.li`
    margin-bottom: 0.5rem;

    &:first-child {
        font-weight: 800;
        font-size: 1.21em;
        margin-bottom: -0.5rem;
    }
`;

const CopyrightDate = styled.span`
    margin: 0 0.25rem 0 1rem;
`;

const MulitSite = styled(Link)`
    margin: 0 1rem;
    text-decoration: underline;
`;

const allCategories = graphql`
    query {
        site {
            siteMetadata {
                title
            }
        }
        categories: allContentfulCategory(sort: { fields: order, order: ASC }) {
            nodes {
                title
                contentful_id
                node_locale
            }
        }
        pages: allContentfulPage {
            nodes {
                title
                contentful_id
                node_locale
                slug
            }
        }
    }
`;

export default () => {
    const [state, setState] = useState({
        submitted: false,
        success: false,
    });

    return (
        <Locale.Consumer>
            {({ locale }) => (
                <StaticQuery
                    query={allCategories}
                    render={(data) => {
                        const cats = filterByLocale(
                            data.categories.nodes,
                            locale,
                        );

                        function onSubmit(token) {
                            document
                                .getElementById('#subscription-form')
                                .submit();
                        }

                        const pgs = filterByLocale(data.pages.nodes, locale);

                        const Categories = cats.map((obj) => {
                            const slug = generateSlug(
                                [locale, lang.products[locale], obj.title].join(
                                    '/',
                                ),
                            );

                            return (
                                <FooterListItem key={obj.contentful_id}>
                                    <Link to={`/${slug}`}>{obj.title}</Link>
                                </FooterListItem>
                            );
                        });

                        const Pages = pgs.map((obj) => {
                            const slug = generateSlug(
                                [locale, obj.slug].join('/'),
                            );

                            return (
                                <FooterListItem key={obj.contentful_id}>
                                    <Link to={`/${slug}`}>{obj.title}</Link>
                                </FooterListItem>
                            );
                        });

                        const formFields = {
                            name: '',
                            email: '',
                            [HoneyPot.ALTERNATIVE_NAME]: '',
                        };

                        return (
                            <Footer>
                                <FooterSearchBar locale={locale} />
                                <FooterContainer>
                                    <Grid>
                                        <Formik
                                            enableReinitialize
                                            initialValues={formFields}
                                            onSubmit={HoneyPot.execute(
                                                (values, { resetForm }) =>
                                                    axios
                                                        .post(
                                                            '/.netlify/functions/newsletter',
                                                            {
                                                                ...values,
                                                                lang: locale.split(
                                                                    '-',
                                                                )[0],
                                                            },
                                                        )

                                                        .then(() => {
                                                            resetForm(
                                                                formFields,
                                                            );
                                                            setState({
                                                                submitted: true,
                                                                success: true,
                                                            });
                                                        })
                                                        .catch(() =>
                                                            setState({
                                                                submitted: true,
                                                                success: false,
                                                            }),
                                                        ),
                                            )}
                                            render={({ setFieldValue }) => (
                                                <FooterRightColumn>
                                                    <FooterList>
                                                        <FooterListItem>
                                                            <h3>
                                                                {
                                                                    lang
                                                                        .newsletter[
                                                                        locale
                                                                    ]
                                                                }
                                                            </h3>
                                                            <p>
                                                                <small
                                                                    style={{
                                                                        marginBottom:
                                                                            '2rem',
                                                                    }}
                                                                >
                                                                    {
                                                                        lang
                                                                            .privacy[
                                                                            locale
                                                                        ]
                                                                    }
                                                                </small>
                                                            </p>
                                                        </FooterListItem>
                                                        <FooterListItem>
                                                            <Input
                                                                full
                                                                type="text"
                                                                name="name"
                                                                required
                                                                title={
                                                                    lang
                                                                        .firstName[
                                                                        locale
                                                                    ]
                                                                }
                                                            />
                                                            <Input
                                                                full
                                                                type="email"
                                                                name={
                                                                    HoneyPot.ALTERNATIVE_NAME
                                                                }
                                                                title={
                                                                    lang.email[
                                                                        locale
                                                                    ]
                                                                }
                                                                required
                                                            />
                                                            <HoneyPot />
                                                        </FooterListItem>
                                                        <FooterListItem
                                                            style={{
                                                                marginTop:
                                                                    '1.5rem',
                                                            }}
                                                        >
                                                            <Button type="submit">
                                                                {
                                                                    lang.signup[
                                                                        locale
                                                                    ]
                                                                }
                                                            </Button>
                                                            {state.submitted && (
                                                                <Alert
                                                                    success={
                                                                        state.success
                                                                    }
                                                                >
                                                                    {state.success
                                                                        ? lang
                                                                              .onSuccess[
                                                                              locale
                                                                          ]
                                                                        : lang
                                                                              .onFail[
                                                                              locale
                                                                          ]}
                                                                </Alert>
                                                            )}
                                                        </FooterListItem>
                                                    </FooterList>
                                                </FooterRightColumn>
                                            )}
                                        />
                                        <FooterLeftColumn>
                                            <Grid>
                                                <FooterList>
                                                    <FooterListItem>
                                                        <h4>
                                                            {
                                                                lang.products[
                                                                    locale
                                                                ]
                                                            }
                                                        </h4>
                                                    </FooterListItem>
                                                    {Categories}
                                                </FooterList>
                                                <FooterList>
                                                    <FooterListItem>
                                                        <h4>
                                                            {lang.about[locale]}
                                                        </h4>
                                                    </FooterListItem>
                                                    {Pages}
                                                </FooterList>
                                            </Grid>
                                        </FooterLeftColumn>
                                    </Grid>
                                    <hr aria-hidden="true" />
                                    <Grid
                                        style={{
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <small>
                                            <img
                                                src="/Leaf.png"
                                                alt={`${data.site.siteMetadata.title} Favicon`}
                                                width="15"
                                            />
                                            <CopyrightDate>
                                                {new Date().getFullYear()}
                                            </CopyrightDate>
                                            {data.site.siteMetadata.title}
                                        </small>

                                        <small>
                                            <MulitSite to="/en-us">
                                                United States
                                            </MulitSite>
                                            <MulitSite to="/en-ca">
                                                Canada
                                            </MulitSite>
                                        </small>
                                    </Grid>
                                </FooterContainer>
                            </Footer>
                        );
                    }}
                />
            )}
        </Locale.Consumer>
    );
};
